




























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Index extends Vue {
  imgUrl = "https://img01.yzcdn.cn/vant/cat.jpeg";
}
